module.exports = __webpack_public_path__ + "img/research-mall-update-group.184bb6b7.jpg";